export default __webpack_public_path__ + "static/media/1.81af0544.png";